import React from "react";

function ExperienceCard({ experience }) {
  if (!experience) return null;

  return (
    <article className="exp">
      <header className="exp-header">
        <div>
          <h2 className="exp-company">{experience.company}</h2>
          <p className="exp-role">{experience.title}</p>
        </div>
        <p className="exp-meta">
          <span>{experience.period}</span>
          {experience.location && (
            <>
              <span aria-hidden="true"> · </span>
              <span>{experience.location}</span>
            </>
          )}
        </p>
      </header>
      {experience.blurb && <p className="prose">{experience.blurb}</p>}
    </article>
  );
}

export default ExperienceCard;
